const initialState = {
  profileTitle: null,
  company: {
    moderationNotification: {
      isVisible: false,
    },
  },
  isSocketConnected: false,
  currentStep: 1,
  hasSurvey: null,
  surveyVacancyData: [],
  surveyData: [],
}

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case 'MOD_UI_IS_VISIBLE':
      return {
        ...state,
        company: {
          ...state.company,
          moderationNotification: {
            ...state.company.moderationNotification,
            isVisible: action.payload,
          },
        },
      }
    case 'SET_PROFILE_TITLE':
      return {
        ...state,
        profileTitle: action.payload,
      }

    case 'SET_IS_SOCKET_CONNECTED': {
      const { status } = action.payload
      return {
        ...state,
        isSocketConnected: status,
      }
    }

    case 'UI_SET_SURVEY_STATUS': {
      const { hasSurvey } = action.payload

      return {
        ...state,
        hasSurvey,
      }
    }

    case 'UI_SET_SURVEY_DATA': {
      return {
        ...state,
        surveyData: action.payload,
      }
    }

    case 'UI_SET_SURVEY_VACANCY_DATA': {
      return {
        ...state,
        surveyVacancyData: action.payload,
      }
    }
    case 'UI_SET_CURRENT_STEP': {
      return {
        ...state,
        currentStep: action.payload,
      }
    }
    case 'UI_CLEAR_SURVEY_STATUS': {
      return {
        ...state,
        currentStep: 1,
        hasSurvey: null,
        surveyVacancyData: [],
        surveyData: [],
      }
    }

    default:
      return state
  }
}
